import axios from "axios";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Div } from "../../StyledComponents";
import {
  Button1,
  Image,
} from "../setting/PatientPortalSettings/StyledComponents";
import { memo } from "react";
import Loader from "../popups/Loading";
import { WhatsNewUrl } from "../../axios/url.js";
import { Tabs } from "antd";
import Emp_data_pic from "../../assets/images/Emp_data_pic.png";
import moment from "moment";
import { Decrypt_Value } from "../schedule/EncryptDecrypt/index.js";
import axiosInstance from "../../axios/axios.js";

const { TabPane } = Tabs;

const NewSource = ({
  newOpen,
  setNewOpen,
  finalURL,
  newPostAlert,
  setNewPostAlert,
}) => {
  const [blogData, setBlogData] = useState([]);
  const [spinner, setspinner] = useState(true);
  const [key, setKey] = useState("latestUpdates");
  const [videoData, setVideoData] = useState([]);

  const handleMore = (title) => {
    window.open(`https://www.vozohealth.com/blog/${title}`, "_blank");
  };

  const handleReleaseNote = () => {
    window.open(
      `https://help.vozohealth.com/product-guide/creating-a-trial-account/`,
      "_blank",
    );
  };

  let releaseNoteBullets = [
    " Fixed issues with Setting up Provider Availability.",
    "Improved Billing setup and Claim generation and Payment processing workflow.",
    "Reinvented note template workflow, which is used for clinical notes & patient forms.",
    "Mainstreamed Service codes and Permission based on providers usage.",
  ];

  useEffect(() => {
    axios
      .get(finalURL + "getNewFeatures.php")
      .then((res) => {
        setBlogData(Array.isArray(res.data) ? res.data : []);
        setspinner(false);
      })
      .catch((err) => {
        setBlogData([]);
        console.log(err.message);
      });

    const alertTimeout = setTimeout(() => {
      if (newPostAlert) {
        axios
          .get(WhatsNewUrl + "newPostAlert.php?type=post")
          .then((response) => {
            if (Number(response.data) === 0) {
              setNewPostAlert(false);
            }
          })
          .catch((err) => {
            console.log(err);
            setNewPostAlert(false);
          });
      }
    }, 5000);

    return () => {
      clearTimeout(alertTimeout);
    };
  }, []);

  useEffect(() => {
    axiosInstance.get(`/vozo/provider/whatsnew`).then((response) => {
      const decrypted = Decrypt_Value(response.data, "vozo");

      let parsed = [];

      try {
        // ✅ If it's already an array of objects
        if (Array.isArray(decrypted) && typeof decrypted[0] === "object") {
          parsed = decrypted;
        }

        // ✅ If it's an array with JSON string
        else if (Array.isArray(decrypted) && typeof decrypted[0] === "string") {
          parsed = JSON.parse(decrypted[0]);
        }

        // ✅ If it's a plain JSON string
        else if (typeof decrypted === "string") {
          parsed = JSON.parse(decrypted);
        }
      } catch (e) {
        console.error("WhatsNew JSON parse failed", e);
        parsed = [];
      }
      setVideoData(Array.isArray(parsed) ? parsed : []);
    });
  }, []);

  const normalizedVideoData = Array.isArray(videoData)
    ? videoData
    : videoData
      ? [videoData]
      : [];
  const combinedData = [
    ...(Array.isArray(blogData) ? blogData : []).map((b) => ({
      id: `blog-${b.id}`,
      type: "blog",
      title: b.title,
      date: b.date,
      content: b.content,
      formatTitle: b.formatTitle,
    })),

    ...normalizedVideoData.map((v) => {
      const cleanLink =
        typeof v.link === "string"
          ? v.link.replace(/^"+|"+$/g, "")
          : Array.isArray(v.link)
            ? v.link[0]
            : "";

      return {
        id: `video-${v.id}`,
        type: "video",
        title: v.title,
        date: v.updated_date,
        videoUrl: cleanLink,
      };
    }),
  ];

  combinedData.sort((a, b) => new Date(b.date) - new Date(a.date));
  return spinner ? (
    <Loader fromWhere="whatsnew_newsource" />
  ) : (
    <Modal
      show={newOpen}
      onHide={() => setNewOpen(false)}
      className="topnav_newSource"
      transition={null}
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title
          style={{
            fontSize: "18px",
            marginTop: "0px",
            marginLeft: "0px",
            fontWeight: "600",
            borderBottom: "none",
          }}
        >
          What's New
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tabs
          activeKey={key}
          onChange={(newKey) => setKey(newKey)}
          aria-label="new-source-tabs"
        >
          <TabPane
            tab={
              <>
                <p
                  className={newPostAlert ? "new_source_latest_red_dot" : ""}
                ></p>
                Latest Updates
              </>
            }
            key="latestUpdates"
          >
            <Div>
              {combinedData.length > 0 ? (
                combinedData.map((item) => (
                  <div key={item.id}>
                    <Div
                      display="flex"
                      alignItems="flex-start"
                      textAlign="left"
                    >
                      <Div
                        fontSize="18px"
                        fontWeight="600"
                        color="#2E2E2E"
                        width="445px"
                      >
                        {item.title}
                      </Div>

                      <Div
                        marginLeft="auto"
                        fontSize="14px"
                        fontWeight="600"
                        paddingLeft="20px"
                        paddingTop="5px"
                        color="rgba(46, 46, 46, 0.5)"
                      >
                        {item.date}
                      </Div>
                    </Div>

                    {/* BLOG → UI EXACTLY SAME */}
                    {item.type === "blog" && (
                      <>
                        <Div fontSize="14px" fontWeight="400" paddingTop="16px">
                          {item.content}
                        </Div>
                        <Button1
                          type="button"
                          fontSize="14px"
                          fontWeight="400"
                          color="#2C7BE5"
                          padding="0px"
                          paddingTop="8px"
                          backgroundColor="#fff"
                          onClick={() => handleMore(item.formatTitle)}
                        >
                          Learn more
                        </Button1>
                      </>
                    )}

                    {/* VIDEO → matches style, no UI change to blog */}
                    {item.type === "video" && (
                      <Div
                        fontSize="14px"
                        fontWeight="500"
                        color="#2563EB"
                        cursor="pointer"
                        paddingTop="8px"
                        display="inline-block"
                        onClick={() =>
                          window.open(
                            item.videoUrl,
                            "_blank",
                            "noopener,noreferrer",
                          )
                        }
                      >
                        Watch Video
                      </Div>
                    )}

                    <hr />
                  </div>
                ))
              ) : (
                <div className="img_top">
                  <Image
                    height="133px"
                    width="100%"
                    margin="0 auto"
                    src={Emp_data_pic}
                  ></Image>
                </div>
              )}
            </Div>
          </TabPane>

          <TabPane tab="Release Notes" key="releaseNotes">
            <Div>
              <Div display="flex" alignItems="flex-start" textAlign="left">
                <Div
                  fontSize="18px"
                  fontWeight="600"
                  color="#2E2E2E"
                  width="445px"
                >
                  Release Notes for March 2025
                </Div>
                <Div
                  marginLeft="auto"
                  fontSize="14px"
                  fontWeight="600"
                  paddingLeft="20px"
                  paddingTop="5px"
                  color="rgba(46, 46, 46, 0.5)"
                >
                  March 21, 2025
                </Div>
              </Div>
              <Div fontSize="14px" fontWeight="400" paddingTop="16px">
                EHR has been completely upgraded with enhanced UI and workflow
                improvements on billing and note templates, making it more
                user-friendly and efficient for healthcare providers. Some of
                the changes that addressed in this improvement are:
              </Div>

              <Div fontSize="14px" fontWeight="400" paddingTop="16px">
                <ul>
                  {releaseNoteBullets.map((notes, index) => (
                    <li key={index}>{notes}</li>
                  ))}
                </ul>
              </Div>

              <Div paddingTop="16px">
                To know more about the recent updates & releases, click
                <Button1
                  type="button"
                  fontSize="14px"
                  fontWeight="400"
                  color="#2C7BE5"
                  padding="0px"
                  paddingTop="8px"
                  backgroundColor="#fff"
                  paddingLeft="5px"
                  onClick={handleReleaseNote}
                >
                  Learn more
                </Button1>
              </Div>
              <hr />
            </Div>
          </TabPane>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
};

export default memo(NewSource);
